import type { ButtonProps } from "../../types/form";
import styles from "./styles.module.css";

const Button = ({
  onClick,
  type = "submit",
  title,
  size = "medium",
  bgColor,
  className,
  disabled,
  loading,
  style,
  removePadding = false,
}: ButtonProps) => {
  return (
    <div
      className={`${styles.InputContainer} ${
        removePadding && styles.NoPadding
      } ${styles[size ? size : ""]}`}
    >
      <button
        type={type}
        onClick={onClick}
        className={`${styles[bgColor ? bgColor : ""]} ${className}`}
        disabled={disabled || loading}
        style={style}
      >
        {title}
        {loading && <span className={styles.loading}></span>}
      </button>
    </div>
  );
};

export default Button;
